import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import CustomerEditPage from './CustomerEditPage';
import { useParams } from "react-router-dom";
const Page = () => {
    const params = useParams();
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: "Customer Details" }), _jsx(CustomerEditPage, { customerId: Number(params.customerId) })] }) }));
};
export default Page;
